import React from "react";
import logo from "../../Assets/logo-autocare.png";



const BizXAutoCare = () => {
  return (
    <img
      style={{ height: 35, pointerEvents: "none", width:165}}
      src={logo}
      alt="logo" />
  );
};

export default BizXAutoCare;
